import React from "react";
import "./Css/Home.css";
import { useNavigate } from "react-router-dom";
import software from "./software.jpg"

const Home = () => {
  const navigate = useNavigate();
  return (
    <div className="home">

      <section className="hero">
        <div className="hero-content">
          <img
            src={software}
            alt="AK Logo"
            className="img"
          />
          <h1>AKES Examination & School Management System</h1>
          <p>
            A smart and reliable platform designed for schools and educational organizations to manage examinations digitally.
            It enables administrators and teachers to create exams, manage question banks, track student performance, and
            generate results efficiently — all from one centralized platform.
          </p>
          <div className="btn">
            <button
              className="hero-btn"
              onClick={() => navigate("/pricing")}
            >
              View Pricing
            </button>
            {/* <button
              className="hero-btn"
              onClick={() => window.open("https://institute.akessoft.in", "_blank")}
            >
              Login
            </button> */}
          </div>
        </div>
      </section>
    </div>

  );
};

export default Home;